import React, { useState } from 'react';
import ButtonOptions from '../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../components/NovoSistema/HeaderButtons';
import AjusteDeSaldo from './AjusteDeSaldo';
import AuditoriaAssociacaoNFe from './AuditoriaAssociacaoNFe';
import ConferenciaDeSaldos from './ConferenciaDeSaldos';
import CurvaABCEstoque from './CurvaABCEstoque';
import Entrada from './Entrada';
import GerencialDeEstoque from './GerencialDeEstoque';
import Inventario from './Inventario';
import Kardex from './Kardex';
import Movimentacao from './Movimentacao';
import ProdutosComSaldoMinimo from './ProdutosComSaldoMinimo';
import ProdutosMaisComprados from './ProdutosMaisComprados';
import RequisicaoDeMaterial from './RequisicaoDeMaterial';
import Reserva from './Reserva';
import SaldoDeEstoque from './SaldoDeEstoque';
import ServicoTomado from './ServicoTomado';
import UsoEConsumo from './UsoEConsumo';

export default function Relatorios() {
  const [option, setOption] = useState('');
  return (
    <main>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Ajuste de Saldo"
          border="#498C29"
          active={option === 'Ajuste de Saldo' ? true : false}
          yourFunction={() => setOption('Ajuste de Saldo')}
        />
        <ButtonOptions
          buttonName="Auditoria Associação NF-e"
          border="#498C29"
          active={option === 'Auditoria Associação NF-e' ? true : false}
          yourFunction={() => setOption('Auditoria Associação NF-e')}
        />
        <ButtonOptions
          buttonName="Conferência de Saldos"
          border="#498C29"
          active={option === 'Conferência de Saldos' ? true : false}
          yourFunction={() => setOption('Conferência de Saldos')}
        />
        <ButtonOptions
          buttonName="Curva ABC Estoque"
          border="#498C29"
          active={option === 'Curva ABC Estoque' ? true : false}
          yourFunction={() => setOption('Curva ABC Estoque')}
        />
        <ButtonOptions
          buttonName="Entrada"
          border="#498C29"
          active={option === 'Entrada' ? true : false}
          yourFunction={() => setOption('Entrada')}
        />
        <ButtonOptions
          buttonName="Gerencial de Estoque"
          border="#498C29"
          active={option === 'Gerencial de Estoque' ? true : false}
          yourFunction={() => setOption('Gerencial de Estoque')}
        />
        <ButtonOptions
          buttonName="Inventário"
          border="#498C29"
          active={option === 'Inventário' ? true : false}
          yourFunction={() => setOption('Inventário')}
        />
        <ButtonOptions
          buttonName="Kardex"
          border="#498C29"
          active={option === 'Kardex' ? true : false}
          yourFunction={() => setOption('Kardex')}
        />
        <ButtonOptions
          buttonName="Movimentação"
          border="#498C29"
          active={option === 'Movimentação' ? true : false}
          yourFunction={() => setOption('Movimentação')}
        />
        <ButtonOptions
          buttonName="Produtos com Saldo Mínimo"
          border="#498C29"
          active={option === 'Produtos com Saldo Mínimo' ? true : false}
          yourFunction={() => setOption('Produtos com Saldo Mínimo')}
        />
        <ButtonOptions
          buttonName="Produtos mais Comprados"
          border="#498C29"
          active={option === 'Produtos mais Comprados' ? true : false}
          yourFunction={() => setOption('Produtos mais Comprados')}
        />
        <ButtonOptions
          buttonName="Requisição de Material"
          border="#498C29"
          active={option === 'Requisição de Material' ? true : false}
          yourFunction={() => setOption('Requisição de Material')}
        />
        <ButtonOptions
          buttonName="Reserva"
          border="#498C29"
          active={option === 'Reserva' ? true : false}
          yourFunction={() => setOption('Reserva')}
        />
        <ButtonOptions
          buttonName="Saldo de Estoque"
          border="#498C29"
          active={option === 'Saldo de Estoque' ? true : false}
          yourFunction={() => setOption('Saldo de Estoque')}
        />
        <ButtonOptions
          buttonName="Serviço Tomado"
          border="#498C29"
          active={option === 'Serviço Tomado' ? true : false}
          yourFunction={() => setOption('Serviço Tomado')}
        />
        <ButtonOptions
          buttonName="Uso e Consumo"
          border="#498C29"
          active={option === 'Uso e Consumo' ? true : false}
          yourFunction={() => setOption('Uso e Consumo')}
        />
      </HeaderButtons>
      {option === 'Ajuste de Saldo' && <AjusteDeSaldo />}
      {option === 'Auditoria Associação NF-e' && <AuditoriaAssociacaoNFe />}
      {option === 'Conferência de Saldos' && <ConferenciaDeSaldos />}
      {option === 'Curva ABC Estoque' && <CurvaABCEstoque />}
      {option === 'Entrada' && <Entrada />}
      {option === 'Gerencial de Estoque' && <GerencialDeEstoque />}
      {option === 'Inventário' && <Inventario />}
      {option === 'Kardex' && <Kardex />}
      {option === 'Movimentação' && <Movimentacao />}
      {option === 'Produtos com Saldo Mínimo' && <ProdutosComSaldoMinimo />}
      {option === 'Produtos mais Comprados' && <ProdutosMaisComprados />}
      {option === 'Requisição de Material' && <RequisicaoDeMaterial />}
      {option === 'Reserva' && <Reserva />}
      {option === 'Saldo de Estoque' && <SaldoDeEstoque />}
      {option === 'Serviço Tomado' && <ServicoTomado />}
      {option === 'Uso e Consumo' && <UsoEConsumo />}
    </main>
  );
}
